import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend
} from 'recharts';
import { Card, CardText, Button } from "react-bootstrap";

const data = [
  { year: '2018', revenue: 15.6 },
  { year: '2019', revenue: 17.1 },
  { year: '2020', revenue: 9.3 },
  { year: '2021', revenue: 11.8 },
  { year: '2022', revenue: 15.2 },
  { year: '2023', revenue: 18.4 },
  { year: '2024', revenue: 20.1 },
  { year: '2025', revenue: 22.1 },
];

export default function ActionRevenueLineGraph() {
  return (
    <div style={{ width: "100%", display: "flex", gap: "1rem", }}>
   <div style={{ flex: 1, position: "relative", minHeight: 0 }}>
     <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 10, right: 25, left: -20, bottom: -20 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#595555" />
          <XAxis
            dataKey="year"
            tick={{ fill: '#fff', fontSize: 14 }}
            stroke="rgba(255,255,255,0.3)"
          />
          <YAxis
            tickFormatter={(v) => `$${v}B`}
            tick={{ fill: '#fff', fontSize: 14 }}
            stroke="rgba(255,255,255,0.3)"
          />
          <Tooltip
            formatter={(value) => [`$${value}B`, 'Global Revenue']}
            contentStyle={{
              backgroundColor: 'rgba(20,19,19,0.9)',
              border: '1px solid rgba(243,174,61,0.4)',
              borderRadius: '8px',
              color: "#cf2b2b",
            }}
          />
          <Legend wrapperStyle={{ color: '#fff' }} />
          <Line
            type="monotone"
            dataKey="revenue"
            name="Global Revenue"
            stroke="#cf2b2b"
            strokeWidth={3}
            dot={{ fill: '#c8d2d3', r: 4 }}
            activeDot={{ r: 7 }}
          />
        </LineChart>
      </ResponsiveContainer>
   </div>


      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "1rem", minHeight: 0, }}>
      <h11 style={{ color: 'white', textAlign: 'center', marginBottom: '0rem' }}>
        Global Action Film Revenue Growth (2018–2024)
      </h11>
     <ul style={{ color: "white", margin: 0, paddingLeft: '1.2rem', lineHeight: '1.8' }}>
  <li>Global action film revenue grew from <strong>$15.6B in 2018</strong> to <strong>$22.1B in 2025</strong> — a CAGR of roughly <strong>5.1%</strong>.</li>
  <li>The pandemic drove a temporary collapse to <strong>$9.3B in 2020</strong>, not a structural decline.</li>
  <li>Since that low point, revenue has rebounded at a CAGR of nearly <strong>19%</strong>.</li>
  <li>Revenue is compounding well above the broader market's post-2020 growth rate, pointing to sustained commercial upside for a well-positioned action property today.</li>
</ul>
      </div>
    </div>
  );
}